/**
 * The configuration of the source of identity variables
 *
 * @public
 */
export interface IdentityPropertySource {
  name: string;
  variable: string;
}

/**
 *
 * @public
 */
export interface IdentitySourceConfig {
  identity?: string;
  email?: string;
  properties?: IdentityPropertySource[];
}

/**
 * A Samelogic user object.
 *
 * Maps 1:1 to LaunchDarkly user object.
 * https://launchdarkly.github.io/node-client-sdk/interfaces/_launchdarkly_node_client_sdk_.lduser.html
 *
 * @public
 */
export interface SLUser {
  key?: string;
  email?: string;
  name?: string;
}
